import { LinkifiedText } from '@/components/linkified-text';
import { Box, Paper, Typography } from '@mui/material';

interface Props {
  note: string | null;
}

export function AssemblyNotesTab({ note }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 3 }}>
      {note ? (
        <Box>
          <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
            <LinkifiedText>{note}</LinkifiedText>
          </Typography>
        </Box>
      ) : (
        <Box>
          <Typography variant="body2" color="text.secondary">
            No notes created
          </Typography>
        </Box>
      )}
    </Paper>
  );
}
